import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Refills from './Refills';

export const RefillsRoutes = (
  <Route path="refills" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician']}>
          <Refills />
        </PrivateRoute>
            )}
    />
  </Route>
);
